import * as _ from 'lodash';
import {
  AssistantPositionX,
  AssistantPositionY,
  ArrowPosition,
  AlignPosition,
} from '../../types/assistant-actions';

//%% make this generic for both backdrop and tooltip

//%% clean this and change the name to AttachableController
export abstract class AttachableController {
  element: HTMLElement;
  elementData: any = {};
  isAttached: boolean;
  attachedToElement: HTMLElement;
  trackChangesIntervalId: any;
  TRACK_CHANGE_INTERVAL: number = 400;

  constructor() {}

  abstract positionElement(
    element: HTMLElement,
    target: HTMLElement,
    positionX,
    positionY,
    offsetX,
    offsetY,
    minY,
    alignTo,
  );

  async attachTo(
    targetElement: HTMLElement,
    positionX: AssistantPositionX,
    positionY: AssistantPositionY,
    offsetX?: number,
    offsetY?: number,
    minY?: number,
    arrowPosition?: ArrowPosition,
    alignTo?: AlignPosition,
  ): Promise<void> {
    if (this.isAttached) {
      throw new Error('Component is already attached, try to detach first');
    }

    this.attachedToElement = targetElement;
    const onChangeCallback = async () => {
      // tslint:disable-next-line: no-floating-promises
      return this.positionElement(
        this.element,
        this.attachedToElement,
        positionX,
        positionY,
        offsetX,
        offsetY,
        minY,
        alignTo,
      );
    };

    this.trackChangesIntervalId = this.trackChanges(
      this.attachedToElement,
      onChangeCallback,
      this.TRACK_CHANGE_INTERVAL,
    );

    this.isAttached = true;
    return onChangeCallback();
  }

  detach(): void {
    if (this.isAttached) {
      window.clearInterval(this.trackChangesIntervalId);
      this.trackChangesIntervalId = null;
      this.isAttached = false;
      //this.attachedToElement.removeData('boundingClientRect');
    }
  }

  private trackChanges(
    target: HTMLElement,
    onChangeCallback: Function,
    checkInterval: number = 250,
  ): number {
    return window.setInterval(
      () => this.notifyChangeIfNeeded(target, onChangeCallback),
      checkInterval,
    );
  }

  private notifyChangeIfNeeded(
    target: HTMLElement,
    onChangeCallback: Function,
  ) {
    const roundedBoundingClientRectOld = this.elementData.boundingClientRect;
    const roundedBoundingClientRectNew = this.getRoundedBoundingClientRect(
      target,
    );
    window.requestAnimationFrame(() => {
      if (
        !_.isEqual(roundedBoundingClientRectOld, roundedBoundingClientRectNew)
      ) {
        onChangeCallback();
      }
      this.elementData.boundingClientRect = roundedBoundingClientRectNew;
    });
  }

  private getRoundedBoundingClientRect(target: HTMLElement) {
    if (!target) {
      return {
        left: -1,
        right: -1,
        top: -1,
        bottom: -1,
        width: 0,
        height: 0,
      };
    }

    const boundingClientRect = target.getBoundingClientRect();
    return {
      left: Number(boundingClientRect.left.toFixed(0)),
      right: Number(boundingClientRect.right.toFixed(0)),
      top: Number(boundingClientRect.top.toFixed(0)),
      bottom: Number(boundingClientRect.bottom.toFixed(0)),
      width: Number(boundingClientRect.width.toFixed(0)),
      height: Number(boundingClientRect.height.toFixed(0)),
    };
  }
}
